import { BlogBulkActions, BlogFilters, BlogPageHeader, BlogTable } from '@/components/blog';
import { ROUTES } from '@/constants/routes';
import { useBlogManagement } from '@/hooks/use-blog-management';
import type { BlogPost } from '@/types/blog';
import { Card } from 'antd';
import { useCallback, type Key } from 'react';
import { useNavigate } from 'react-router-dom';

const BlogPage = () => {
  const navigate = useNavigate();

  const {
    posts,
    loading,
    total,
    currentPage,
    pageSize,
    searchText,
    selectedCategory,
    selectedStatus,
    sortBy,
    sortOrder,
    selectedRowKeys,
    bulkLoading,
    handleSearch,
    handleCategoryFilter,
    handleStatusFilter,
    clearFilters,
    handleTableChange,
    handleDeleteBlogPost,
    handleBulkDelete,
    setSelectedRowKeys,
    refetch,
  } = useBlogManagement();

  const handleAddPost = useCallback(() => {
    navigate(ROUTES.BLOG_CREATE);
  }, [navigate]);

  const handleEditPost = useCallback(
    (post: BlogPost) => {
      navigate(ROUTES.BLOG_EDIT.replace(':id', post.id));
    },
    [navigate]
  );

  const rowSelection = {
    selectedRowKeys,
    onChange: (keys: Key[]) => setSelectedRowKeys(keys as string[]),
  };

  return (
    <div>
      <BlogPageHeader
        onRefresh={() => refetch()}
        onAddPost={handleAddPost}
        loading={loading}
        estimatedRecordCount={total}
      />

      <BlogFilters
        searchText={searchText}
        selectedCategory={selectedCategory}
        selectedStatus={selectedStatus}
        onSearch={handleSearch}
        onCategoryFilter={handleCategoryFilter}
        onStatusFilter={handleStatusFilter}
        onClearFilters={clearFilters}
      />

      <BlogBulkActions
        selectedCount={selectedRowKeys.length}
        loading={bulkLoading}
        onBulkDelete={() => handleBulkDelete(selectedRowKeys)}
        onClearSelection={() => setSelectedRowKeys([])}
      />

      <Card className="admin-card">
        <BlogTable
          posts={posts}
          loading={loading}
          pagination={{
            current: currentPage,
            pageSize,
            total,
            showSizeChanger: true,
            showTotal: (count) => `Total ${count} posts`,
          }}
          rowSelection={rowSelection}
          onChange={handleTableChange}
          onEdit={handleEditPost}
          onDelete={handleDeleteBlogPost}
          sortBy={sortBy}
          sortOrder={sortOrder}
        />
      </Card>
    </div>
  );
};

export default BlogPage;
